import { Injectable } from '@angular/core';
import { Howl } from 'howler';
import { RequestsService } from './requests.service';

@Injectable({
  providedIn: 'root'
})
export class RingtoneService {

  constructor(
    private requestService: RequestsService
  ) { }

  private vibrationInterval?: any;

  public sound = new Howl({
    src: ['assets/sounds/ringtone.mp3'],
    html5: true
  }); 

  playRingtone() {
    if (!this.sound.playing()) {
      this.sound.play();
    }
  }

  stopRingtone() {
    if (this.sound.playing()) {
      this.sound.stop();
    }
  }
}